import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = {
  key: 1,
  class: "position-absolute p-2 top-50 start-0 ext-select-checkbox",
  style: {"z-index":"1","width":"auto","margin-top":"-1rem"}
}
const _hoisted_5 = ["checked", "onClick"]
const _hoisted_6 = { class: "position-relative col d-flex justify-content-center align-items-center card" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 3,
  class: "col-12 g-0"
}
const _hoisted_9 = { class: "position-relative col d-flex justify-content-center align-items-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  style: {"position":"absolute","bottom":"0.4rem","right":"0.4rem","z-index":"2"}
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 1,
  class: "fw-bold text-muted"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Clickable = _resolveComponent("Clickable")!
  const _component_Image = _resolveComponent("Image")!
  const _component_VRuntimeTemplate = _resolveComponent("VRuntimeTemplate")!
  const _component_ItemCatalogsDetailsModal = _resolveComponent("ItemCatalogsDetailsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref: "root",
      class: _normalizeClass(["pis-component", _ctx.componentName]),
      part: _ctx.componentName
    }, [
      (_ctx.isReady)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.isWebComponent)
              ? (_openBlock(), _createBlock(_component_InjectStyles, {
                  key: 0,
                  items: _ctx.store?.options.styles
                }, null, 8, ["items"]))
              : _createCommentVNode("", true),
            (_ctx.productsItems && _ctx.productsItems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsItems, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.productId,
                      class: _normalizeClass(["card mb-3 p-3", {
            'pt-0': !_ctx.widerThan('md'),
            'bg-light': item.exactMatch,
            'ext-selected': _ctx.instance?.selection.isSelected(item),
          }])
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        (_ctx.previewEnabled)
                          ? (_openBlock(), _createBlock(_component_Clickable, {
                              key: 0,
                              class: "position-absolute p-2 top-0 start-0 d-flex ext-icon-preview",
                              style: {"z-index":"1","width":"auto"},
                              title: _ctx.t('Preview', true),
                              disabled: _ctx.isPreviewDisabled(item),
                              onClick: ($event: any) => (
                  !_ctx.isPreviewDisabled(item) &&
                    _ctx.previewByProductId(
                      item.baseProduct?.productId || item.alternateProductId || item.productId,
                    )
                )
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Icon, {
                                  glyph: "preview",
                                  lg: ""
                                })
                              ]),
                              _: 2
                            }, 1032, ["title", "disabled", "onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.componentOptions.selectable)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "form-check-input",
                                checked: _ctx.instance?.selection.isSelected(item),
                                onClick: ($event: any) => (_ctx.instance?.selection.toggle(item))
                              }, null, 8, _hoisted_5)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.widerThan('md'))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: _normalizeClass([_ctx.previewEnabled ? 'ms-4' : '', 'col']),
                              style: _normalizeStyle({ 'max-width': _ctx.componentOptions.imageSize })
                            }, [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_Image, {
                                  style: _normalizeStyle({ 'max-width': _ctx.componentOptions.imageSize }),
                                  src: _ctx.getItemImage(item),
                                  clickable: _ctx.componentOptions.navigateOnContentClick && !_ctx.isPreviewDisabled(item),
                                  "hide-frame": true,
                                  padding: _ctx.componentOptions.imagePadding,
                                  onClick: ($event: any) => (_ctx.details(item))
                                }, null, 8, ["style", "src", "clickable", "padding", "onClick"]),
                                (_ctx.componentOptions.imageOverlayTemplate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                      _createVNode(_component_VRuntimeTemplate, {
                                        template: _ctx.componentOptions.imageOverlayTemplate,
                                        "template-props": { instance: _ctx.instance, item: item, emit: _ctx.emit, t: _ctx.t }
                                      }, null, 8, ["template", "template-props"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 6))
                          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_Image, {
                                  class: "mt-3",
                                  style: { 'max-width': '300px' },
                                  src: _ctx.getItemImage(item),
                                  clickable: _ctx.componentOptions.navigateOnContentClick && !_ctx.isPreviewDisabled(item),
                                  "hide-frame": true,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-content')))
                                }, null, 8, ["src", "clickable"]),
                                (_ctx.componentOptions.imageOverlayTemplate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                      _createVNode(_component_VRuntimeTemplate, {
                                        template: _ctx.componentOptions.imageOverlayTemplate,
                                        "template-props": { instance: _ctx.instance, item: item, emit: _ctx.emit, t: _ctx.t }
                                      }, null, 8, ["template", "template-props"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])),
                        _createElementVNode("div", {
                          class: _normalizeClass([_ctx.widerThan('md') ? 'col' : 'col-12 mt-3'])
                        }, [
                          (_ctx.componentOptions.detailsVisible)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("a", {
                                  href: "",
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleItemDetails(item)), ["prevent"]),
                                  class: "btn btn-link text-dark d-flex align-items-center"
                                }, [
                                  _createVNode(_component_Icon, {
                                    glyph: "plus",
                                    class: "py-1",
                                    style: {"font-size":"1.1rem"}
                                  })
                                ], 8, _hoisted_12)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.componentOptions.titleTemplate)
                            ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                key: 1,
                                template: _ctx.componentOptions.titleTemplate,
                                "template-props": {
                    instance: _ctx.instance,
                    item,
                    emit: _ctx.emit,
                    details: _ctx.details,
                    baseProductDetails: _ctx.baseProductDetails,
                    attrValue: _ctx.attrValue,
                    t: _ctx.t,
                  }
                              }, null, 8, ["template", "template-props"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (item.inactive)
                                  ? (_openBlock(), _createElementBlock("strong", _hoisted_13, _toDisplayString(_ctx.attrValue(item, '#DisplayName')), 1))
                                  : (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.details(item)), ["prevent"])
                                    }, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.attrValue(item, '#DisplayName')), 1)
                                    ], 8, _hoisted_14))
                              ], 64)),
                          (_ctx.componentOptions.showAllIdentifiers)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.attrValues(item, '#AllIdentifiers'), (val, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "small text-muted fw-bold",
                                  key: index
                                }, _toDisplayString(val), 1))
                              }), 128))
                            : _createCommentVNode("", true),
                          (_ctx.componentOptions.itemTemplate)
                            ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                key: 4,
                                template: _ctx.componentOptions.itemTemplate,
                                "template-props": {
                    instance: _ctx.instance,
                    item,
                    emit: _ctx.emit,
                    details: _ctx.details,
                    baseProductDetails: _ctx.baseProductDetails,
                    attrValue: _ctx.attrValue,
                    t: _ctx.t,
                  }
                              }, null, 8, ["template", "template-props"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.attrValue(item, '#Description')), 1)
                                ]),
                                (item.customerClassification)
                                  ? (_openBlock(), _createElementBlock("em", _hoisted_15, [
                                      _createTextVNode(_toDisplayString(_ctx.t('CustomerClassification')) + ":  " + _toDisplayString(item.customerClassification) + " ", 1),
                                      _hoisted_16
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.baseProduct)
                                  ? (_openBlock(), _createElementBlock("em", _hoisted_17, [
                                      _createTextVNode(_toDisplayString(_ctx.t('BaseProductId')) + ":  ", 1),
                                      (!item.baseProduct.inactive)
                                        ? (_openBlock(), _createBlock(_component_Clickable, {
                                            key: 0,
                                            onClick: ($event: any) => (_ctx.baseProductDetails(item.baseProduct))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.baseProduct.productId), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.baseProduct.productId), 1)),
                                      _hoisted_19
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                        ], 2),
                        (_ctx.componentOptions.additionalColumnTemplate)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 4,
                              class: _normalizeClass([
                _ctx.widerThan('md')
                  ? 'col-' + _ctx.componentOptions.additionalColumnTemplateWidth
                  : 'col-12 mt-3',
              ])
                            }, [
                              _createVNode(_component_VRuntimeTemplate, {
                                template: _ctx.componentOptions.additionalColumnTemplate,
                                "template-props": {
                  instance: _ctx.instance,
                  item,
                  emit: _ctx.emit,
                  details: _ctx.details,
                  baseProductDetails: _ctx.baseProductDetails,
                  attrValue: _ctx.attrValue,
                  t: _ctx.t,
                }
                              }, null, 8, ["template", "template-props"])
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.showActionTemplate(item))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 5,
                              class: _normalizeClass([
                _ctx.widerThan('md') ? 'col-' + _ctx.componentOptions.actionTemplateWidth : 'col-12 mt-3',
              ])
                            }, [
                              _createVNode(_component_VRuntimeTemplate, {
                                template: _ctx.componentOptions.actionTemplate,
                                "template-props": {
                  instance: _ctx.instance,
                  item,
                  emit: _ctx.emit,
                  details: _ctx.details,
                  baseProductDetails: _ctx.baseProductDetails,
                  attrValue: _ctx.attrValue,
                  t: _ctx.t,
                }
                              }, null, 8, ["template", "template-props"])
                            ], 2))
                          : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1),
    _createVNode(_component_ItemCatalogsDetailsModal, {
      "instance-id": _ctx.instanceId,
      item: _ctx.selectedItem,
      show: _ctx.catalogsModalVisible,
      t: _ctx.t,
      "all-catalogs": _ctx.showingAllCatalogs,
      onHidden: _cache[1] || (_cache[1] = ($event: any) => (_ctx.catalogsModalVisible = false))
    }, null, 8, ["instance-id", "item", "show", "t", "all-catalogs"])
  ], 64))
}